import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Sparkles, Clock } from "lucide-react";
import { NAV, SITE } from "@/lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-950 text-slate-300 pt-20 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-14 border-b border-slate-800">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-5">
              <img src="/LogoAnusha.png" alt="Dr. Anusha Mandava Logo" className="h-12 w-auto brightness-0 invert opacity-90" />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-md">
              Compassionate, evidence-based radiation oncology care in
              Hyderabad. Patient-specific treatment planning across breast,
              gynecological, head &amp; neck, and other cancers.
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">
              Navigate
            </div>
            <ul className="space-y-2.5 text-sm">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">
              Reach Out
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${SITE.phoneRaw}`}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-slate-400 hover:text-white"
                >
                  <Phone className="h-4 w-4 mt-0.5 text-blue-300" />
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${SITE.email}`}
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-slate-400 hover:text-white break-all"
                >
                  <Mail className="h-4 w-4 mt-0.5 text-blue-300 shrink-0" />
                  {SITE.email}
                </a>
              </li>

              <li className="flex items-start gap-3 text-slate-400">
                <Clock className="h-4 w-4 mt-0.5 text-blue-300" />
                {SITE.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            Copyright © {new Date().getFullYear()} Dr. Anusha Mandava. All rights reserved. Developed by <a href="https://www.getaivry.com/" target="_blank" rel="noreferrer" className="text-blue-400 hover:text-blue-300">Aivry</a>.
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
